<template>
  <div :class="['footer-container',currentPath=='20th-anniversary'?'thombrowne20th':'',currentPath=='homecollection'?'homecollection':'',currentPath=='eyewear'?'eyewear':'',glassType?glassType:'']" v-show="isShow">
    <part-line
      :prartName="prartName"
      :partItem="partItem"
      :showPart="showPart"
      :currentPath="currentPath"
      v-if="currentPath!='homecollection'"
    ></part-line>
    <footer :class="['footer_pc',currentPath=='20th-anniversary'?'thombrowne20th':'']" v-if="footDetails.length > 0">

      <div class="item-list">
      
        <div
          class="item left"
          v-for="(menuItem, index) in footDetails"
          :key="index"
        >
          <ul class="left1">
            <li :class="['menu_title']" @click="chooseMenu(index + 1)">
              <span v-if="!menuItem.linkUrl" class="first_menu_title">{{
                menuItem.thisOne.name
              }}</span>
              <a v-else target="_self" :href="menuItem.linkUrl?(hrefhost+menuItem.linkUrl):'javascript:void(0);'"  class="first_menu_title">{{
                menuItem.thisOne.name
              }}</a>
            </li>
            <li v-for="(menuItem1, index1) in menuItem.nextList" :key="index1">
              <img
                class="psb-icon"
                src="../../assets/image/logo/psb-icon.png"
                v-if="index == 2 && index1 == 4"
              />
              <!-- <template v-if="menuItem1.thisOne.name=='视频咨询'">
               
              <Poptip trigger="hover" placement="right">
                <a @click="goPage(menuItem1.thisOne)">{{menuItem1.thisOne.name}} 
                </a>
               <template #content>
                <div style="text-align:center;padding:1.2rem 0">
                 <img
                   class="wxewm"
                   src="https://oss-cn-shanghai.aliyuncs.com/connectplus/origin/202301/45b38970f37e62d4c24567a04cb7431c.png"
                   style="width:12rem;height:12rem"
                 />
                  <div style="margin-top:0.5rem;font-size: 9px;color: #68696B;font-weight: 400;">微信扫码查看</div>
                </div>
               </template>
           </Poptip>
       
              </template> -->
              <template>
                <span style="cursor: pointer;" v-if="!menuItem1.thisOne.linkUrl" @click="goPage(menuItem1.thisOne)">{{menuItem1.thisOne.name}} </span>
                <a  v-else target="_self" :href="menuItem1.thisOne.linkUrl" >{{menuItem1.thisOne.name}} 
                </a>
              </template>
            
            </li>
          </ul>
        </div>
      </div>
    </footer>
    <footer class="footer_mb">
      <Collapse v-model="detailType" accordion>
        <Panel
          v-for="(menuItem2, index) in footDetails"
          :key="index"
          :name="index.toString() + 1"
          @click="chooseDetail(index + 1)"
        >
          {{ menuItem2.thisOne.name }}
          <span class="action"></span>
          <div slot="content">
            <ul class="left1">
              <li
                v-for="(menuItem3, index1) in menuItem2.nextList"
                :key="index1"
                @click="goPage(menuItem3.thisOne)"
                v-show="menuItem3.thisOne.name!='视频咨询'"
              >
                <img
                  class="psb-icon"
                  src="../../assets/image/logo/psb-icon.png"
                  v-if="index == 2 && index1 == 4"
                />
                {{menuItem3.thisOne.name}}
              </li>
            </ul>
          </div>
        </Panel>
      </Collapse>
    </footer>
    <div :class="['zixun',currentPath=='20th-anniversary'?'thombrowne20th':'']">
      <span @click="toSub">订阅我们的资讯</span>
    </div>
    <div :class="['copy',currentPath=='20th-anniversary'?'thombrowne20th':'']">©2021 THOM BROWNE, INC.</div>
    <we-chat :wechatPop="wechatPop" v-on:close="closeWechat"></we-chat>
    <SubPop></SubPop>
  </div>
</template>

<script>
import {
  checkLinkUrl,
  getEntityIdByLink,
  getFriendlyUrlType,
} from "../../utils/utils";
import $ from "jquery";
import PartLine from "../common/PartLine";
import WeChat from "./WeChatPop";
import SubPop from "../common/SubPop";
export default {
  name: "Footer",
  data() {
    return {
      isShow: false,
      subModal: false,
      subModalEnd: false,
      partItem: null,
      friendlyUrlType: "",
      currentPath:'',
      wechatPop: false,
      hrefhost:window.location.protocol+'//'+window.location.host,
      friendly_url: this.$route.params.friendly_url,
      detailType: "1",
      // footDetails: [],
      // prartName: null,
      showType: "1",
      isMobStyle: false,
      glassType:this.$store.state.glassType,
      showMenu: false, //显示手机版本footer子菜单
    };
  },
  components: { PartLine, WeChat, SubPop },
  watch: {
    showWeChat() {
      if (this.$store.state.showWeChatPop) {
        this.wechatPop = true;
      }
    },
    "$store.state.glassType":function(newVal, oldVal) {
       this.glassType=newVal;
    },
    $route: function (newVal, oldVal) {
      // this.setFooterText();
      // var friendlyUrlObj = getFriendlyUrlType({}, { link: newVal }, this);
      // console.log("friendlyUrlObj", friendlyUrlObj);
    
      let _path = this.$route.path;
      if(_path.indexOf("20th-anniversary")>-1){
         this.currentPath='20th-anniversary'
      }else if(_path.indexOf("home-collection")>-1){
        this.currentPath='homecollection'
      }else if(window.location.href=='http://localhost:8080/eyewear'||window.location.href=='https://tb-test.getconnectplus.com/eyewear'||window.location.href=='https://www.thombrowne.cn/eyewear'||window.location.href=='https://www.thombrowne.cn/preview/eyewear'){
       
        this.currentPath='eyewear'
      } else{
        this.currentPath=''
      }
      if (_path == "/checkout" || _path == "/checkoutPay"||_path.indexOf('instore-registration')>-1||_path.indexOf('h5tomp')>-1) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
      this.setFooterText(newVal.params.friendly_url);
    },
  },

  beforeRouteLeave: function () {
    // this.setFooterText();
  },
  computed: {
    showWeChat() {
      return this.$store.state.showWeChatPop;
    },
    prartName: function () {
      return this.$store.state.partName;
    },
    showPart: function () {
      return this.$store.state.showPart;
    },
    footDetails() {
      return this.$store.state.footerList;
    },
  },

  created() {
    var that = this;
    setTimeout(() => {
      let _path = this.$route.path;
      if (_path == "/checkout" || _path == "/checkoutPay"||_path.indexOf('instore-registration')>-1||_path.indexOf('h5tomp')>-1) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    }, 1000);
    // that.getHeadAndFoot();
    that.setFooterText(that.$route.params.friendly_url);
  },
  methods: {
    setFooterText(friendly_url) {
      var that = this;
      var data = window.localStorage.getItem("entityId");
      var entityId = "";
      if (data) entityId = data.id;
      if (entityId == undefined || entityId == "undefined") entityId = "";
      let url =
        that.$store.state.API.sys.getByTextPositionId +
        "?positionId=" +
        entityId;
      that.$http.get(url, {}).then((res) => {
        if (res.status == 200 && res.data.message == "success") {
          if (res.data.returnData) {
            that.partItem = res.data.returnData;
            that.$store.commit("setPartName", that.partItem.title);
          }
        } else {
        }
      });
      // var that = this;
      // //自动监测friendly 类型
      // var friendlyUrlObj = getFriendlyUrlType(
      //   {},
      //   { link: this.$route.path },
      //   this
      // );
      // this.friendlyUrlType = friendlyUrlObj.friendlyUrlType;
      // let params = {
      //   friendlyUrlType: this.friendlyUrlType,
      //   link: friendly_url,
      // };
      // getEntityIdByLink(
      //   function(data) {
      //     var entityId = "";
      //     if (data) entityId = data.id;
      //     if (entityId == undefined || entityId == "undefined") entityId = "";
      //     let url =
      //       that.$store.state.API.sys.getByTextPositionId +
      //       "?positionId=" +
      //       entityId;
      //     that.$http.get(url, {}).then((res) => {
      //       if (res.status == 200 && res.data.message == "success") {
      //         if (res.data.returnData) {
      //           that.partItem = res.data.returnData;
      //           that.$store.commit("setPartName", that.partItem.title);
      //         }
      //       } else {
      //       }
      //     });
      //   },
      //   params,
      //   this
      // );
      // }
    },

    closeWechat() {
      this.wechatPop = false;
    },
    getHeadAndFoot() {
      var that = this;
      let url = this.$store.state.API.plp.getHeadAndFoot;
      let paramsObj = {
        merchantId: this.$store.state.storeId,
        source: "PC",
      };
      this.$http.get(url + "?" + that.$qs.stringify(paramsObj)).then((res) => {
        if (res.status == 200) {
          if (res.data.returnData.footDetails) {
            this.footDetails = res.data.returnData.footDetails.details;
          }
        }
      });
    },
    chooseDetail(type) {
      this.detailType = type;
    },

    goPage(item) {
      var that = this;
      if (item.linkUrl == "/account/order-list") {
        if (!window.localStorage.getItem("token")) {
          this.$store.commit("setValue", ["showLoginPop", true]);
          return;
        }
      }
      if (item.name == "微信") {
        this.wechatPop = true;
      } else {
        let params = {
          link: item.linkUrl,
          newWindows: item.newWindows,
        };
        checkLinkUrl(function (data) {}, params, that);
      }
    },
    chooseMenu(type) {
      this.showType = type;
      this.isMobStyle = true;
      this.showMenu = !this.showMenu;
    },
    goWeb(type) {
      var url = null;
      if (type == "resources") {
        url = "https://changes.getconnectplus.com/";
      } else if (type == "help") {
        url = "https://help.getconnectplus.com/";
      }
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        window.location.href = url;
      } else {
        var tempwindow = window.open("_blank");
        tempwindow.location = url;
      }
    },
    toSub() {
      if (!window.localStorage.getItem("token")) {
        this.$store.commit("setValue", ["showLoginPop", true]);
      } else {
        this.$store.commit("setValue", ["showSubPop", true]);
      }
    },
  },
};
</script>

<style scoped lang="less">
@blue: #1f88e5;
.footer-container {
  &.SUNGLASSES{
    background: #5c5d5f;
    .footer_pc{
      border: none!important;
    }
    ul{
        li{
          color: #ffffff!important;
          a{
            color: #ffffff!important;
          }
        }
      }
      .zixun{
        border-top: none;
        span{
          color: #ffffff!important;
        }
      }
      .copy{
        border-top: none;
        color: #ffffff!important;
      }
  }
  &.thombrowne20th{
    background: #BFC1C3;
  }
  &.homecollection{
      background: #3A3A3A;
      ul{
        li{
          color: #ffffff!important;
          a{
            color: #ffffff!important;
          }
        }
      }
     
      .footer_pc{
        border-top: none;
      }
      .zixun{
        border-top: none;
        span{
          color: #ffffff!important;
        }
      }
      .copy{
        border-top: none;
        color: #ffffff!important;
      }
    }
  .footer_pc {
    display: block;
   
    &.thombrowne20th{
      background: #BFC1C3;
      // border-top:.1rem solid #BFC1C3;

    }
  }
  .footer_mb {
    display: none;
  }
  footer {
    padding: 4.5rem 5rem 2.2rem;
    border-top: 0.1rem solid #eaeaea;
    .item-list {
      display: flex;
      align-items: flex-start;
      justify-content: space-around;
      text-align: left;
      padding: 0px 5rem;
      color: #5c5d5f;
      font-size: 12px;
      text-transform: uppercase;
      padding-bottom: 2.2rem;
      .item {
        font-family: ArialNarrow, sans-serif;

        a {
          color: #5c5d5f;
          &:hover {
            text-decoration: initial;
            // font-weight: 500;
            text-shadow: 0 0 0.2px #5c5d5f, 0 0 0.2px #5c5d5f;
          }
        }
        .menu_title {
          text-decoration: underline;
          a.first_menu_title{
            cursor: pointer;
          }
          .first_menu_title {
            font-weight: inherit;
            cursor: initial;
            &:hover {
              text-shadow: none;
            }
          }
        }

        ul li {
          padding-bottom: 1.5rem;
          display: flex;
          align-items: center;
        }
      }
    }
  }
  .zixun {
    text-align: center;
    padding-top: 4rem;
    padding-bottom: 4rem;
    border-top: 0.1rem solid #eaeaea;
    &.thombrowne20th{
      background: #BFC1C3;
    }
    > span:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .psb-icon {
    width: 1.2rem;
    height: 1.2rem;
    vertical-align: middle;
  }
  .copy {
    text-align: center;
    padding: 2rem 5rem;
    border-top: 0.1rem solid #eaeaea;
    font-family: ArialNarrow, sans-serif;
    &.thombrowne20th{
      background: #BFC1C3;
    }
  }
}
@media screen and (max-width: 1024px) {
  .homecollection{
    /deep/.ivu-collapse-header{
      background: #fff!important;
      color: #ffffff!important;
    }
  }
  .footer-container{
    &.SUNGLASSES{
    background: #fff;
    ul{
        li{
          color: #5c5d5f!important;
          a{
            color: #5c5d5f!important;
          }
        }
      }
      .zixun{
        border-top: .1rem solid #eaeaea;
        span{
          color: #5c5d5f!important;
        }
      }
      .copy{
        border-top: .1rem solid #eaeaea;
        color: #5c5d5f!important;
      }
  }
  }
  
  .footer-container {
    padding: 4.5rem 2rem 2.2rem;
    // margin:0  - 2rem;
  }
}
@media screen and (max-width: 768px) {
  /deep/.ivu-modal {
  }
  .footer-container {
    padding: 0rem 0rem 2.2rem;
    margin: 0;
    footer {
      padding: 0 2rem;
      border-top: none;
    }
    .footer_pc {
      display: none;
    }
    .footer_mb {
      display: block;
      ul {
        margin: 0 2rem;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        li {
          margin-bottom: 2rem;
          width: 100%;
        }
      }
    }
    .zixun {
      text-align: center;
      padding: 2.2rem 0;
    }
  }
}
/deep/.ivu-modal {
  top: 200px;
}
/deep/.ivu-collapse > .ivu-collapse-item {
  // margin: 0 -1rem;
}
/deep/.ivu-collapse > .ivu-collapse-item > .ivu-collapse-header {
  padding: 2rem 2rem;
  height: initial;
  line-height: initial;
  font-family: ArialNarrow, sans-serif;
  text-decoration: underline;
}
/deep/.ivu-collapse-content > .ivu-collapse-content-box {
  font-family: ArialNarrow, sans-serif;
  padding: 0;
}
/deep/.ivu-collapse
  > .ivu-collapse-item.ivu-collapse-item-active
  > .ivu-collapse-header {
  text-decoration: underline;
}
/deep/.ivu-collapse
  > .ivu-collapse-item.ivu-collapse-item-active
  > .ivu-collapse-header {
  border-bottom: none;
}
/deep/.ivu-collapse {
  border-top: 0.1rem solid #eaeaea;
  border-bottom: none;
}
/deep/.ivu-modal-body {
  padding: 22px 20px 40px 20px;
}
.close_box {
  display: flex;
  .close_icon {
    cursor: pointer;
    margin-left: auto;
    width: 7px;
    height: 9px;
    margin-bottom: 15px;
  }
}
.modal_content {
  .sub_img {
    width: 100%;
    height: 178px;
    margin-bottom: 30px;
  }
  .sub_text {
    text-align: left;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5c5d5f;
  }
  .sub_btn {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 36px;
    background: #5c5d5f;
    border: 1px solid #5c5d5f;
    line-height: 34px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 10px;
    margin-top: 33px;
    padding: 0px 20px;
  }
  .sub_btn_cancel {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 34px;
    background: #ffffff;
    border: 1px solid #5c5d5f;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #5c5d5f;
    line-height: 32px;
    padding: 0px 20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue